import React, { useState } from 'react'
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';


export default function ContactScreen() {
    const [formData, setFormData] = useState({
        fullName: "",
        city: "",
        phone: "",
        email: "",
        description: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleCansel = () => {
        setFormData({
            fullName: "",
            phone: "",
            city: "",
            email: "",
            description: ""
        });
    };

    const handleSendMessage = () => {
        const { fullName, phone, email, description, city } = formData;

        const mailtoLink = `mailto:zeacoprofile@gmail.com
                ?subject=Enquiry from ${fullName}
                &body=Full Name: ${fullName}%0A
                Phone: ${phone}%0A
                Email: ${email}%0A
                City: ${city}%0A
                Description: ${description}%0A`;

        window.location.href = mailtoLink.replace(/\s/g, "");
        setTimeout(() => {
            setFormData({ fullName: "", phone: "", email: "", description: "", city: "" });
        }, 500);
    };


    return (
        <div className='ContactScreen'>
            <div className="Contact_home">
                <div className="h1 p-3 text_main shadow container pt-4">Contact Us</div>
                <div className="h4 text-white container my-0">
                    We hope you have found everything you need to know about Zeaco Industries, If you have additional questions, feel free to Contact Us.</div>
                <div className="container Contact_Content">
                    <div className="">
                        <div className="row d-flex justify-content-between">
                            <div className="col-12 col-md-6 my-2">
                                <div className="shadow card p-4 h-100">
                                    <div className="text_main h4">Address</div>
                                    <div className="h5 my-2 mt-3">GSTIN : <span className='text_main'>24GYWPK2839B2Z4</span></div>
                                    <div className="h5 my-2 mt-3">REGISTERED OFFICE ADDRESS</div>
                                    <p className='text-muted' style={{ fontSize: "20px" }}>
                                        Plot No. 54 & 57, <br />
                                        Nandanvan Industrial Park - 2,
                                        <br />
                                        Indore Ahmedabad Highway, <br />
                                        Bakrol,
                                        Ahmedabad - 382430
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 my-2">
                                <div className="shadow card p-4 h-100">
                                    <div className="text_main h4">Mobile</div>
                                    <p className='text-muted' style={{ fontSize: "20px" }}>+91 85111 39999 <br />
                                        +91 99747 00343</p>
                                    <div className="text_main h4">Email</div>
                                    <p className='text-muted' style={{ fontSize: "20px" }}> zeacoprofile@gmail.com</p>
                                    <div className="text_main h4">Web Address</div>
                                    <p className='text-muted' style={{ fontSize: "20px" }}> zeacoprofile.com</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="section">
                <div className="container">
                    <div className="h1 text-center text_main">Request a Call Back</div>
                    <div className="h5 text-center">Drop Us a Message, While Right Back to You Shortly</div>
                    <div>
                        <DialogContent>
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <TextField
                                        required
                                        margin="dense"
                                        name="fullName"
                                        label="Full Name"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        sx={{
                                            "& label.Mui-focused": {
                                                color: "rgb(4, 150, 63)",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "rgb(4, 150, 63)",
                                                },
                                            },
                                        }}
                                    />
                                </div>
                                <div className="col-md-6 col-12">
                                    <TextField
                                        required
                                        margin="dense"
                                        name="city"
                                        label="City"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={formData.city}
                                        onChange={handleChange}
                                        sx={{
                                            "& label.Mui-focused": {
                                                color: "rgb(4, 150, 63)",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "rgb(4, 150, 63)",
                                                },
                                            },
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <TextField
                                        required
                                        margin="dense"
                                        name="phone"
                                        label="Phone Number"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        sx={{
                                            "& label.Mui-focused": {
                                                color: "rgb(4, 150, 63)",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "rgb(4, 150, 63)",
                                                },
                                            },
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <TextField
                                        required
                                        margin="dense"
                                        name="email"
                                        label="Email Address"
                                        type="email"
                                        fullWidth
                                        variant="outlined"
                                        value={formData.email}
                                        onChange={handleChange}
                                        sx={{
                                            "& label.Mui-focused": {
                                                color: "rgb(4, 150, 63)",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "rgb(4, 150, 63)",
                                                },
                                            },
                                        }}
                                    />
                                </div>
                                <div className="col-12">
                                    <TextField
                                        label="Description"
                                        margin="dense"
                                        multiline
                                        fullWidth
                                        rows={4}
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        sx={{
                                            "& label.Mui-focused": {
                                                color: "rgb(4, 150, 63)",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "rgb(4, 150, 63)",
                                                },
                                            },
                                        }}
                                    />
                                    <br /><br />
                                </div>
                                <div className="col-12">
                                    <div className="text-muted">
                                        For any Query, please mail to: &nbsp;
                                        <a className='text_main' href="mailto:zeacoprofile@gmail.com?subject=Enquiry">
                                            zeacoprofile@gmail.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <button className='btn btn_outline' onClick={handleCansel}>Cancel</button>
                            <button className='btn_primary btn' onClick={handleSendMessage}>Send Message</button>
                        </DialogActions>
                    </div>
                </div>
            </div>
        </div>
    )
}
